import styled, { keyframes } from "styled-components";

const animaIcon = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(100deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
  height: 300px;

  .icone {
    animation: 2s ${animaIcon} infinite linear;
    -webkit-animation: 2s ${animaIcon} infinite linear;
    -moz-animation: 2s ${animaIcon} infinite linear;
    -ms-animation: 2s ${animaIcon} infinite linear;
    -o-animation: 2s ${animaIcon} infinite linear;
  }
`;
